import { Component, Inject, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Category, InfoItem } from 'src/app/components/generics/data-printer/data-printer.component';

export interface WarrantyValidationStatusCategory {
    name: string;
    fields: string[];
    link?: string;
}

@Component({
    selector: 'app-warranty-validation-dialog',
    templateUrl: './warranty-validation-dialog.component.html',
    styleUrls: ['./warranty-validation-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WarrantyValidationDialogComponent {

    @ViewChild('categoryButtonTemplate', { static: true })
    categoryButtonTemplate: TemplateRef<any>;

    constructor(
        public dialogRef: MatDialogRef<WarrantyValidationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: WarrantyValidationStatusCategory[]
    ) { }

    ngOnInit() {
    }

    cerrarDialogo(update: boolean) {
        this.dialogRef.close(update);
    }

    generateCategories(): Category[] {
        return this.data.filter(validationStatus => validationStatus.fields.length > 0).map(validationStatus => {
            const items: InfoItem[] = validationStatus.fields.map(field => ({ value: field, alignment: 'center' }));
            if (validationStatus.link) {
                items.push({ template: this.categoryButtonTemplate, templateParams: { link: validationStatus.link }, className: 'warranty-validation-category-template' });
            }
            return { name: validationStatus.name, items };
        });
    }
}
